import aomTables from './admin.aom.js';
import cdTables from './admin.cd.js';

export default [...aomTables, ...cdTables];
